import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import { showToastError } from 'src/utilities/errortoast';

export const syncAppointmentsDryRun = (payload) => {
  return async (dispatch) => {
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await Axios.post(
        '/appointments/sync?dry_run=true',
        payload,
        {
          headers,
        }
      );
      if (result?.status === 200) {
        return result.data;
      } else {
        showToastError('Failed to upload appointments');
      }
    } catch (error) {
      console.error(error);
      showToastError(`Error uploading appointments: ${error.message}`);
    }
  };
};

export const syncAppointments = (payload) => {
  return async (dispatch) => {
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await Axios.post('/appointments/sync', payload, {
        headers,
      });
      if (result?.status === 200) {
        return result.data;
      } else {
        showToastError('Failed to upload appointments');
      }
    } catch (error) {
      console.error(error);
      showToastError(`Error uploading appointments: ${error.message}`);
    }
  };
};
